<template>
    <div
        v-if="isOpen"
        class="fixed inset-0 z-50 flex items-start justify-center pt-10 bg-black bg-opacity-50"
        @click="handleClickOutside"
    >
        <div
            class="relative w-3/4 h-auto p-6 overflow-y-auto bg-white rounded-lg"
            @click.stop
        >
            <div class="flex items-center justify-between mb-6">
                <h2 class="text-xl font-bold">{{ title }}</h2>
                <button
                    type="button"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    @click="closeModal"
                    class="text-gray-500 transition duration-150 hover:text-gray-700"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-6 h-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>
            </div>

            <form class="space-y-6" @submit.prevent="submit">
                <div
                    class="flex flex-col space-y-4 md:flex-row md:space-x-4 md:space-y-0"
                >
                    <div class="flex-1">
                        <label
                            for="setactive"
                            class="flex items-center space-x-2"
                        >
                            <input
                                type="checkbox"
                                id="setactive"
                                class="sr-only peer"
                                :checked="form.setactive"
                                @change="handleToggle('setactive')"
                            />
                            <span
                                class="relative inline-block h-8 transition bg-gray-300 rounded-full cursor-pointer w-14 peer-checked:bg-blue-500"
                            >
                                <span
                                    class="absolute inset-y-0 left-0 w-6 h-6 m-1 transition-transform transform bg-white rounded-full peer-checked:translate-x-6"
                                ></span>
                            </span>
                            <span>Set Active</span>
                        </label>
                        <InputError
                            :message="form.errors.setactive"
                            class="mt-2"
                        />
                    </div>
                </div>

                <!-- Toggle Button untuk WA Service -->
                <div
                    class="flex flex-col space-y-4 md:flex-row md:space-x-4 md:space-y-0"
                >
                    <div class="flex-1">
                        <label
                            for="waservice"
                            class="flex items-center space-x-2"
                        >
                            <input
                                type="checkbox"
                                id="waservice"
                                class="sr-only peer"
                                :checked="form.waservice"
                                @change="handleToggle('waservice')"
                            />
                            <span
                                class="relative inline-block h-8 transition bg-gray-300 rounded-full cursor-pointer w-14 peer-checked:bg-blue-500"
                            >
                                <span
                                    class="absolute inset-y-0 left-0 w-6 h-6 m-1 transition-transform transform bg-white rounded-full peer-checked:translate-x-6"
                                ></span>
                            </span>
                            <span>WA Service</span>
                        </label>
                        <InputError
                            :message="form.errors.waservice"
                            class="mt-2"
                        />
                    </div>
                </div>
                <div
                    class="flex flex-col space-y-4 md:flex-row md:space-x-4 md:space-y-0"
                >
                    <div class="flex-1">
                        <InputLabel
                            for="tanggal_aktivasi"
                            label="Tanggal Aktivasi"
                        />
                        <InputField
                            type="date"
                            id="tanggal_aktivasi"
                            v-model="form.tanggal_aktivasi"
                        />
                        <InputError
                            :message="form.errors.tanggal_aktivasi"
                            class="mt-2"
                        />
                    </div>
                    <div class="flex-1">
                        <InputLabel
                            for="tanggal_expired"
                            label="Tanggal Expired"
                        />
                        <InputField
                            type="date"
                            id="tanggal_expired"
                            v-model="form.tanggal_expired"
                        />
                        <InputError
                            :message="form.errors.tanggal_expired"
                            class="mt-2"
                        />
                    </div>
                </div>

                <div
                    class="flex flex-col space-y-4 md:flex-row md:space-x-4 md:space-y-0"
                >
                    <div class="flex-1">
                        <label for="Prodi">Fakultas</label>
                        <select
                            v-model="form.fakultas_id"
                            @change="getDepartemen"
                            class="block w-full px-3 py-2 text-gray-900 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        >
                            <option value="">Pilih Fakultas</option>
                            <option
                                v-for="fakultas in fakultas.data"
                                :key="fakultas.id"
                                :value="fakultas.id"
                            >
                                {{ fakultas.name }}
                            </option>
                        </select>
                        <InputError
                            :message="form.errors.fakultas_id"
                            class="mt-2"
                        />

                        <label for="Prodi">Jurusan</label>
                        <select
                            v-model="form.departemen_id"
                            @change="getProdi"
                            class="block w-full px-3 py-2 text-gray-900 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        >
                            <option value="" disabled>Pilih Jurusan</option>
                            <option
                                v-for="departemen in localDepartemen"
                                :key="departemen.id"
                                :value="departemen.id"
                            >
                                {{ departemen.name }}
                            </option>
                        </select>
                        <InputError
                            :message="form.errors.departemen_id"
                            class="mt-2"
                        />

                        <label for="Prodi">Program Studi</label>
                        <select
                            v-model="form.kodeprodi"
                            class="block w-full px-3 py-2 text-gray-900 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        >
                            <option value="" disabled>
                                Pilih Program Studi
                            </option>
                            <option
                                v-for="prodi in localProdi"
                                :key="prodi.id"
                                :value="prodi.id"
                                :selected="prodi.id == form.kodeprodi"
                            >
                                {{ prodi.jenjang }} | {{ prodi.name }}
                            </option>
                        </select>
                        <InputError
                            :message="form.errors.prodi_id"
                            class="mt-2"
                        />
                    </div>
                </div>
                <div class="flex justify-end space-x-4">
                    <button
                        type="button"
                        @click="submit"
                        class="px-4 py-2 mt-4 text-white bg-gray-800 rounded"
                    >
                        Simpan
                    </button>
                    <button
                        type="button"
                        @click="closeModal"
                        class="px-4 py-2 mt-4 text-white bg-red-500 rounded"
                    >
                        Tutup
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, watch, ref, reactive, inject } from "vue";
import { useForm } from "@inertiajs/vue3";
import InputLabel from "./InputLabel.vue";
import InputError from "./InputError.vue";
import InputField from "./InputField.vue";
import Swal from "sweetalert2";
const route = inject('route');

const props = defineProps({
    isOpen: {
        type: Boolean,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
    fakultas: {
        type: Object,
        required: true,
    },
    departemen: {
        type: Array,
        required: true,
    },
    prodi: {
        type: Array,
        required: true,
    },
    activ: {
        type: Array,
        required: true,
    },
});

const emit = defineEmits(["update:isOpen"]);

const form = useForm({
    id: null,
    setactive: 0,
    waservice: 0,
    tanggal_aktivasi: "",
    tanggal_expired: "",
    kodeprodi: "",
});
const handleToggle = (field) => {
    form[field] = form[field] === 1 ? 0 : 1;
};

const localDepartemen = ref(props.departemen ? [...props.departemen] : []);
const localProdi = ref(props.prodi ? [...props.prodi] : []);
// Close modal function
const closeModal = () => {
    emit("update:isOpen", false);
};

// Handle clicking outside the modal to close it
const handleClickOutside = (event) => {
    if (event.target === event.currentTarget) {
        closeModal();
    }
};

const getDepartemen = (event) => {
    form.fakultas_id = event.target.value;
    form.departemen_id = "";
    //   form.kodeprodi = "";
    if (form.fakultas_id) {
        fetch(route("jurusan.show", form.fakultas_id))
            .then((response) => response.json())
            .then((data) => {
                localDepartemen.value = Array.isArray(data.data)
                    ? data.data
                    : [];
            })
            .catch((error) => {
                console.error(
                    "There was an error fetching the departemen data:",
                    error
                );
            });
    }
};
const getProdi = (event) => {
    form.departemen_id = event.target.value;
    form.kodeprodi = "";
    if (form.departemen_id) {
        fetch(route("prodi.show", form.departemen_id))
            .then((response) => response.json())
            .then((data) => {
                localProdi.value = Array.isArray(data.data) ? data.data : [];
            })
            .catch((error) => {
                console.error(
                    "There was an error fetching the prodi data:",
                    error
                );
            });
    }
};
watch(
    () => props.departemen,
    (newDepartemen) => {
        localDepartemen.value = [...newDepartemen];
    }
);
watch(
    () => props.activ,
    (newAktiv) => {
        if (newAktiv) {
            form.id = newAktiv.id;
            form.setactive = newAktiv.setactive;
            form.waservice = newAktiv.waservice;
            form.tanggal_aktivasi = newAktiv.tanggal_aktivasi;
            form.tanggal_expired = newAktiv.tanggal_expired;
            form.kodeprodi = newAktiv.kodeprodi;
        }
    },
    { immediate: true, deep: true }
);

const submit = () => {
    const routeName = form.id ? "aktivasi.update" : "aktivasi.store";
    form[form.id ? "put" : "post"](route(routeName, form.id || {}), {
        onSuccess: () => {
            form.reset();
            closeModal();
            // Swal.fire({
            //     title: "Berhasil!",
            //     text: `Data berhasil ${form.id ? "diperbarui" : "disimpan"}.`,
            //     icon: "success",
            //     confirmButtonText: "OK",
            // }).then(() => {
            //     closeModal();
            //     // window.location.reload();
            // });
        },
    });
};
</script>

<style scoped></style>
